import { formatDate } from '@shared/utils';

import { TaskInformation } from '../../components';
import { useQuestionReviewTaskDetails } from '../../providers';

export default function QuestionReviewSubtaskInformation() {
  const {
    taskDetails: { parentTask, owner, assignee, dueDate },
  } = useQuestionReviewTaskDetails();

  const subtaskInformationContent = [
    { label: 'Task Name', value: parentTask?.name ?? '-' },
    { label: 'Owner', value: `${owner.firstname} ${owner.lastname}` },
    { label: 'Reviewer', value: `${assignee.firstname} ${assignee.lastname}` },
    { label: 'Due Date', value: formatDate(dueDate) },
  ];

  return <TaskInformation content={subtaskInformationContent} />;
}
